import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgShare = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-share';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M11.24 5.287v3.107l-1.77.018c-1.415.014-1.838.031-2.11.083-1.979.38-3.312 1.626-3.838 3.585-.255.95-.282 1.428-.282 4.994v3.023l2.09-2.083c1.15-1.145 2.234-2.196 2.41-2.335s.433-.303.57-.366c.47-.214.66-.241 1.84-.262l1.09-.019v6.788l4.91-4.91L21.06 12l-4.91-4.91-4.91-4.91zm4.61 9.803-3.09 3.09v-4.625l-1.99.014-1.99.014-.397.11a4.5 4.5 0 0 0-1.483.734c-.198.149-.762.668-1.254 1.152l-.894.881.018-1.58c.015-1.261.032-1.652.087-1.935.275-1.442.956-2.356 2.067-2.773.667-.25.768-.259 3.426-.28l2.41-.02V5.82l3.09 3.09L18.94 12z"
    })
  }));
});
export default SvgShare;